import React from "react";
import { Button, ui } from "./common/ui";

// Shared pagination: 50 / 100 / 200 per page (changeable), Prev / Next and
// "Page x of y · a–b of N". `page` is 0-based. Same API as the Pager that is private to
// ArsManagementPage.js.
export const PAGE_SIZE_OPTIONS = [50, 100, 200];

export default function Pager({ page, pageCount, onPage, total, pageSize, onPageSize }) {
  const showSize = onPageSize && total > PAGE_SIZE_OPTIONS[0];
  if (pageCount <= 1 && !showSize) return null;
  const from = total ? page * pageSize + 1 : 0;
  const to = Math.min(total, (page + 1) * pageSize);
  return (
    <nav aria-label="Pagination" style={{ display: "flex", alignItems: "center", gap: 10, marginTop: 12, justifyContent: "flex-end", flexWrap: "wrap" }}>
      <span style={{ fontSize: 12.5, color: "var(--text-muted)", fontVariantNumeric: "tabular-nums", marginRight: "auto" }}>
        Page {page + 1} of {pageCount} · {from.toLocaleString("en-IN")}–{to.toLocaleString("en-IN")} of {total.toLocaleString("en-IN")}
      </span>
      {showSize && (
        <select
          aria-label="Rows per page"
          value={pageSize}
          onChange={(e) => { onPageSize(Number(e.target.value)); onPage(0); }}
          style={{ ...ui.input, padding: "4px 8px", fontSize: 12.5, cursor: "pointer" }}
        >
          {PAGE_SIZE_OPTIONS.map((n) => <option key={n} value={n}>{n} / page</option>)}
        </select>
      )}
      <Button size="sm" variant="secondary" disabled={page === 0} onClick={() => onPage(Math.max(0, page - 1))}>‹ Prev</Button>
      <Button size="sm" variant="secondary" disabled={page >= pageCount - 1} onClick={() => onPage(Math.min(pageCount - 1, page + 1))}>Next ›</Button>
    </nav>
  );
}
